import { CSSProperties, ReactElement } from "react";

import { BookingCalendarColumnPassengersCell } from "./booking-calendar.column-passengers.cell";
import { BookingCalendarRowDatesCell } from "./booking-calendar.head-row.dates.cell";
import { BookingCalendarHeadRowFirstCell } from "./booking-calendar.head-row.first-cell";
import { BookingCalendarTableBodyCell } from "./booking-calendar.table-body.cell";

export const BookingCalendarCellRenderStrategy = ({
  style,
  rowIndex,
  columnIndex,
}: {
  style: CSSProperties;
  rowIndex: number;
  columnIndex: number;
}): ReactElement => {
  if (rowIndex === 0 && columnIndex === 0) {
    return <BookingCalendarHeadRowFirstCell style={style} />;
  }

  if (columnIndex === 0) {
    return (
      <BookingCalendarColumnPassengersCell
        style={style}
        columnIndex={columnIndex}
        // first row and first column are frozen
        rowIndex={rowIndex - 1}
      />
    );
  }

  if (rowIndex === 0) {
    return (
      <BookingCalendarRowDatesCell
        style={style}
        // first row and first column are frozen
        columnIndex={columnIndex - 1}
        rowIndex={rowIndex}
      />
    );
  }

  return (
    <BookingCalendarTableBodyCell
      style={style}
      // first row and first column are frozen
      columnIndex={columnIndex - 1}
      rowIndex={rowIndex - 1}
    />
  );
};
